import React, { Component } from "react";
import Cognito from "src/js/Cognito.js";
import Api from "src/js/Api.js";
import { Route, Switch } from "react-router-dom";
import NoMonthlyData from "src/component/MonthlyReport/NoMonthlyData";
import CarInfo from "src/component/Util/CarInfo";
import DatePikerForm from "src/component/Util/DatePikerForm";
import ScoreGraph from "src/component/Util/ScoreGraph";
import ScoreChart from "src/component/Util/ScoreChart";
// import { Button, Row, Col, Collapse } from "react-bootstrap";
import { Button, Row, Col, OverlayTrigger, Popover} from 'react-bootstrap';
import Modal from "src/js/Modal.js";
import ApiErrorModal from "src/js/ApiErrorModal.js";
import Config from "src/config.json";
import moment from "moment";
import "src/css/MonthlyReport.css";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class MonthlyReport extends Component {
  constructor() {
    super();
    let today = new Date();
    this.state = {
      // ログイン中ユーザ
      cognitoUser: [],
      // ログイン者のsub
      sub: "",
      // 車両のカープレートNO
      carPlateNo: "",
      // 選択可能な最小の日
      minDate: "0/1/2018",
      // 取得月
      scoreMonth: "",
      // 取得年
      scoreYear: "",
      // 車両のスコア
      scoreData: 0,
      // その他の車両情報
      carOtherInfo: [],
      // 車両情報データローディング
      carInfoLoading: false,
      // 車両情報存在フラグ
      isCarInfo: true,
      // スコア情報存在フラグ
      isScore: true,
      // 月次スコアグラフデータ
      monthlyScoreGraphData: {},
      // 月次グラフデータ
      monthlyScoreGraphLabels: {},
      // 月次スコアグラフデータローディング
      monthlyScoreGraphLoading: true,
      // 月次スコアグラフデータ存在フラグ
      isMonthlyScoreGraph: true,
      // 月次スコアグラフデータ開封フラグ
      isOpenMonthlyScoreGraph: false,
      modalApiPath: "",
      modalStatusCode: "",
      modalErrorMessage: "",
      modalApiMessage: "",
      today: `${("0" + today.getDate()).slice(-2)}/${("0" + (today.getMonth() + 1)).slice(-2)}/${today.getFullYear()}`,
    };
    this.getLocalStorageData = this.getLocalStorageData.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
  }

  componentWillMount() {
    // 認証チェック
    if (Cognito.signInCheck()) {
      // ユーザを取得
      this.setState({ cognitoUser: Cognito.getCognitoUser() });
    }
    // 描画前にローカルストレージからデータを取得する
    this.getLocalStorageData();
  }

  componentDidMount() {
    // ページの一番上までスクロール
    window.scrollTo(0, 0);
    this.getCarInfo();
    this.getMonthlyScoreGraph();
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  // ローカルストレージの値を取得
  getLocalStorageData() {
    // サブ情報
    let sub = localStorage.getItem("sub");
    if (sub) {
      this.setState({
        sub: sub,
      });
    }

    // カープレートNO
    let carPlateNo = localStorage.getItem("carPlate");
    if (carPlateNo) {
      this.setState({
        carPlateNo: carPlateNo,
        carInfoLoading: true,
        isCarInfo: true,
      });
    }

    // 取得年
    let scoreYear = localStorage.getItem("scoreYear");
    if (!scoreYear) {
      scoreYear = moment().month() !== 0 ? moment().year() : moment().year() - 1;
    }
    this.setState({
      scoreYear: scoreYear,
    });

    // 取得月
    let scoreMonth = localStorage.getItem("scoreMonth");
    if (!scoreMonth) {
      scoreMonth = moment().month() !== 0 ? moment().month() : 12;
    }
    this.setState({
      scoreMonth: scoreMonth,
    });
  }

  // 日付選択時車両情報を再取得
  selectDate(date) {
    const scoreYear = date.year();
    const scoreMonth = date.month() + 1;

    this.setState(
      {
        scoreYear: scoreYear,
        scoreMonth: scoreMonth,
      },
      function () {
        this.getCarInfo();
      }
    );
  }

  createEvaluation(data) {
    let evaluation = "";
    for (var i = 0; i < 5; i++) {
      if (i < data) {
        evaluation = evaluation + "★";
      } else {
        evaluation = evaluation + "☆";
      }
    }
    return evaluation;
  }

  // 車両情報を取得
  getCarInfo() {
    // subが無い場合は失敗とする
    if (!this.state.sub) {
      this.setState({
        isCarInfo: false,
        carInfoLoading: false,
      });
      return;
    }

    let _this = this;

    const year = this.state.scoreYear;
    const month = this.state.scoreMonth;

    let queryParams = {
      sub: this.state.sub,
      targetYear: year,
      targetMonth: month,
    };

    this.setState({
      isCarInfo: true,
      carInfoLoading: true,
    });

    // ローカルストレージに保存
    localStorage.setItem("scoreYear", year);
    localStorage.setItem("scoreMonth", month);

    // APIの実行
    Api.runApi(
      this.state.cognitoUser,
      Config.API.STAGE + Config.API.MONTHLY_REPORT.MONTHLY_SCORE_DATA_PATH,
      queryParams
    )
      .then(function onFulfilled(result) {
        const monthlyData = [
          { name: "HB 5 stars rating", value: result.data ? result.data.harshBrakingEval : 0 },
          { name: "Harsh Braking Count (/100km)", value: result.data ? result.data.harshBrakingCount : 0 },
          { name: "Harsh Braking Count (/Month)", value: result.data ? result.data.harshBrakingCountScore : 0 },
          { name: "HA 5 stars rating", value: result.data ? result.data.harshAccelerationEval : 0 },
          { name: "Hard Acceleration Count (/100km)", value: result.data ? result.data.harshAccelerationCount : 0 },
          { name: "Hard Acceleration Count (/Month)", value: result.data ? result.data.harshAccelerationCountScore : 0 },
          { name: "CR 5 stars rating", value: result.data ? result.data.corneringEval : 0 },
          { name: "Cornering Count (/100km)", value: result.data ? result.data.corneringEvalCount : 0 },
          { name: "Cornering Count (/Month)", value: result.data ? result.data.corneringEvalCountScore : 0 },
          { name: "Distance", value: result.data ? result.data.distance : 0 },
          { name: "Duration", value: result.data ? result.data.duration : 0 },
        ];

        let min = result.data ? result.data.duration % 60 : 0;
        let hour = result.data ? parseInt((result.data.duration - min) / 60, 10) : 0;

        // Stateを更新
        _this.setState({
          scoreData: result.data ? result.data.score : 0,
          distance: result.data ? result.data.distance : 0,
          durationMin: min,
          durationHour: hour,
          monthlyData: monthlyData,
          carInfoLoading: false,
          isScore: result.data ? true : false,
        });
      })
      .catch(function onRejected(err) {
        console.log(err);
        _this.setState({
          isCarInfo: false,
          carInfoLoading: false,
          showModal: true,
          modalErrorMessage: "MonthlyScoreApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err,
        });
        return;
      });
  }

  // 最新月次スコアを取得
  getMonthlyScoreGraph() {
    // subが無い場合は失敗とする
    if (!this.state.sub) {
      this.setState({
        isMonthlyScoreGraph: false,
        monthlyScoreGraphLoading: false,
      });
      return;
    }

    let _this = this;

    let queryParams = {
      sub: this.state.sub,
    };

    this.setState({
      isMonthlyScoreGraph: true,
      monthlyScoreGraphLoading: true,
    });

    // APIの実行
    Api.runApi(
      this.state.cognitoUser,
      Config.API.STAGE + Config.API.MONTHLY_REPORT.MONTHLY_GRAPH_DATA_PATH,
      queryParams
    )
      .then(function onFulfilled(result) {
        // 月を英語に変換
        let labels = [];
        if (result.data.labels) {
          for (let i = 0; i < result.data.labels.length; i++) {
            labels.push(
              moment({
                years: 2018,
                months: result.data.labels[i] - 1,
                days: 1,
              }).format("MMM")
            );
          }
        }

        // Stateを更新
        _this.setState({
          monthlyScoreGraphData: result.data,
          monthlyScoreGraphLabels: labels,
          monthlyScoreGraphLoading: false,
        });
      })
      .catch(function onRejected(err) {
        console.log(err);
        _this.setState({
          isMonthlyScoreGraph: false,
          monthlyScoreGraphLoading: false,
          showModal: true,
          modalErrorMessage: "MonthlyScoreGraphApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err,
        });
        return;
      });
  }

  onClick() {
    this.setState({
      isOpenMonthlyScoreGraph: this.state.isOpenMonthlyScoreGraph
        ? false
        : true,
    });
  }

  render() {
    const {t} = this.props;
    const popoverbottom = (
      <Popover id="popover-bottom" className="PopoverLayout">
        <Col md={12} sm={12} xs={12} className="Graph">
          <ScoreGraph
            title={t('MonthlyReport.MonthlyScore')}
            graphData={this.state.monthlyScoreGraphData}
            labels={this.state.monthlyScoreGraphLabels}
            isData={this.state.isMonthlyScoreGraph}
            loading={this.state.monthlyScoreGraphLoading}
          />
        </Col>
      </Popover>
    );

    if (this.state.error) {
      throw new Error(this.state.error);
    }

    return (
      <div>
        <Modal isAospBrowser={false} isLocalStorage={true} />
        <Switch>
          {/* マンスリーレポート画面 */}
          <Route exact path="/monthly_report">
            <div>
              {this.state.showModal && (
                <ApiErrorModal
                  handleHideModal={this.handleHideModal}
                  modalErrorMessage={this.state.modalErrorMessage}
                  modalApiPath={this.state.modalApiPath}
                  modalStatusCode={this.state.modalStatusCode}
                  modalApiMessage={this.state.modalApiMessage}
                />
              )}
              <Row>
                <Col md={12} sm={12} xs={12}>
                  <NoMonthlyData isScore={this.state.isScore} />
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <CarInfo carPlateNo={this.state.carPlateNo} isData={this.state.isCarInfo} loading={this.state.carInfoLoading} />
                  <OverlayTrigger placement="bottom" trigger="click" overlay={popoverbottom}>
                    <Button block variant="primary" className="monthly-score">
                      {t('Common.ScoreChart')}
                    </Button>
                  </OverlayTrigger>
                </Col>
              </Row>
              <Row className="parentchart" id="score-grid">
                <Col className="charttest" id="daughnut-chart">
                  <DatePikerForm
                    month={this.state.scoreMonth}
                    year={this.state.scoreYear}
                    isDate={false}
                    maxDate={this.state.today}
                    minDate={this.state.minDate}
                    selectDate={this.selectDate}
                  />
                  <div className="mini-div" />
                  <div>{t('Common.Score')}</div>
                  <ScoreChart scoreData={this.state.scoreData} isData={this.state.isCarInfo} loading={this.state.carInfoLoading} />
                </Col>
                <Col className="charttest" id="star-rating">
                  <CarInfo
                    carPlateNo={this.state.carPlateNo}
                    carOtherInfo={this.state.monthlyData}
                    isData={this.state.isCarInfo}
                    loading={this.state.carInfoLoading}
                  />
                </Col>
              </Row>
              <Row id="scores">
                <Col md={6} sm={6} xs={6}>  
                  <div>
                    {t('Common.Distance')}<br/>
                    {this.state.distance}
                  </div>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <div>
                    {t('MonthlyReport.Duration')} <br/>
                    {this.state.durationHour}hrs {this.state.durationMin}mins
                  </div>
                </Col>
              </Row>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default withTranslation()(MonthlyReport);



// WEBPACK FOOTER //
// ./src/component/MonthlyReport/MonthlyReport.js